const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSatoshiTango(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7680",
    d: "M4.98,8.35h3.37l1.98.83V3l-5.36,5.35Z",
    style: {
      fill: "#1d43fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7681",
    d: "M8.35,9.52v-1.17h-3.38s3.38,3.32,3.38,3.32v-2.16Z",
    style: {
      fill: "#001db4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7682",
    d: "M13.02,10.31l-4.67-1.96v6.65s4.67-4.69,4.67-4.69Z",
    style: {
      fill: "#51ebc0"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatoshiTango);
export default __webpack_public_path__ + "static/media/satoshi-tango.67d028f8292ae308c30290fa0b6505a9.svg";
export { ForwardRef as ReactComponent };